import { useParams } from 'react-router-dom';
import axios from 'axios';
import TaskDesc from './taskDESC';
import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import './styles.css';
import { EffectCards } from 'swiper/modules';
import AtomicSpinner from 'atomic-spinner';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProjects } from './redux/actions/projectsActions';
import "./task.css"

const Task = () => {
  const projects = useSelector(state => state.projects);
  const [project, setProject] = useState({});
  const { ID } = useParams();
  console.log(ID);

  useEffect(() => {
    const selectedProject = projects.find(project => project._id === ID);
    setProject(selectedProject);
    console.log(ID);
    console.log(project);
  }, [ID, projects]);

  return (
    <>
      <div id="task_app" className="slider_container">
        {project && <h1 className="heading">{project.name}</h1>}
        {project && (
          <Swiper
            effect={'cards'}
            grabCursor={true}
            modules={[EffectCards]}
            className="mySwiper"
          >
            {project.images &&
              project.images.map((image, index) => (
                <SwiperSlide key={index}>
                  <img
                    className="imggg"
                    src={require(`../../../portfolio-backend/NewImages/${project.name}/${project._id}_${index}.png`)}
                    alt="slide_image"
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        )}
        {project && (
          <TaskDesc
            min={project.name}
            desc={project.description}
            title={project.name}
            abrev={project.abrev}
          />
        )}
      </div>
    </>
  );
};

export default Task;
